import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c89036dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c89036dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89036dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c89036dc')) {
      api.createRecord('c89036dc', component.options)
    } else {
      api.reload('c89036dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c89036dc&scoped=true", function () {
      api.rerender('c89036dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/authOrg/index.vue"
export default component.exports